<template>
  <Head>
    <title>{{ templateName }} - {{ setting.brandShortName }}</title>
  </Head>
  <div class="um-no-capture flex h-screen flex-wrap justify-center xl:flex-nowrap xl:items-start">
    <div
      v-if="slides.length"
      class="slider-width"
    >
      <Gallery
        :carousel-data="slides"
        :carousel-type="carouselType"
        :display-settings="displaySettings"
      />
    </div>
    <div
      :style="slides.length > 0 ? 'overflow: auto' : ''"
      :class="isClone ? 'clone-site-align' : 'items-center'"
      class="slider-width mx-2 flex h-full justify-center lg:mx-0"
    >
      <div class="btn-width-main ">
        <Logo :logo="template.logo" />
        <Card
          v-if="!isAddCardShow"
          class="card-main"
          :header-slot-class="headerSlotClass"
          :main-slot-class="mainSlotClass"
          :footer-slot-class="footerSlotClass"
        >
          <template #header>
            <Header
              :title="template.name"
              :monetize="template.is_monetized"
              :price="price"
              :interval="interval"
            />
          </template>
          <template #main>
            <Body
              :process-status="processStatus"
              :template="template"
              :price="price"
              :interval="interval"
              :form="form"
              :errors="errors"
              :purchase-status="purchaseStatus"
              :fail-reason="failReason"
              :progress-percentage="getLaunchSiteProgress"
              :progress-status="getLaunchSiteStatus"
              :site-details="ordered_site"
              :progress-heading="getLaunchSiteMessage.heading"
              :progress-sub-heading="getLaunchSiteMessage.subHeading"
              :processing="processing"
              :is-user-exist="isUserExist"
              @click_add_card="addCardClick"
              @start-process="startProcess"
            />
          </template>
          <template #footer>
            <Footer
              :process-status="processStatus"
              :purchase-status="purchaseStatus"
              :monetize="template.is_monetized"
              :price="price"
              :interval="interval"
              :is-clone="!template.auto_launch && template.site_cloning"
              :is-cloning="isClone"
              :form="form"
              :display-settings="displaySettings"
              :auto-launch="template.auto_launch"
              :is-user-exist="isUserExist"
              :collect-name="template.collect_name"
              @start-process="startProcess()"
              @clone-site="cloneSite()"
              @purchase-site="purchaseSite()"
              @proceed="launchSite()"
              @back="back()"
              @magic-login="magicLogin()"
            />
          </template>
        </Card>
        <AddCard
          v-else
          @close_addCard="closeAddCard"
        />
        <div
          v-if="(processStatus == 'complete') && !template.auto_launch && (template.site_cloning || !template.is_monetized)"
        >
          <Clone
            v-if="isClone"
            :is-user="isUser"
            :signup-form="signupForm"
            :signup-errors="signupErrors"
            :cloning="cloning"
            :display-settings="displaySettings"
            @create-user="createUser()"
          />
        </div>
        <div
          v-if="!template.is_monetized"
          class="mt-8 text-center"
        >
          <span
            class="inline-block cursor-pointer bg-gray-100 px-2.5 py-0.5 text-xs font-medium text-grayCust-500"
            data-v-536c8ec0=""
          ><svg
            xmlns="http://www.w3.org/2000/svg"
            class="mr-1 inline size-4"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            data-v-536c8ec0=""
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
              data-v-536c8ec0=""
            />
          </svg><span
            id="site_will_expire"
            class="leading-loose"
            data-v-536c8ec0=""
          >{{ $t('this_site_will_expire') }} {{ expiredText }}.</span></span>
        </div>
      </div>
    </div>
    <Payment
      :url="verifyURL"
      :is-open3-d-modal="isOpen3DModal"
    />
  </div>
</template>

<script>

import Payment from '@/Common/3DPayment.vue'
import Card from '@/Common/Card.vue'
import Gallery from '@/Common/Gallery.vue'
import AddCard from '@/components/Template/SharedLaunch/AddCard.vue'
import Body from '@/components/Template/SharedLaunch/Body.vue'
import Clone from '@/components/Template/SharedLaunch/Clone.vue'
import Footer from '@/components/Template/SharedLaunch/Footer.vue'
import Header from '@/components/Template/SharedLaunch/Header.vue'
import Logo from '@/components/Template/SharedLaunch/Logo.vue'
import { setCanonicalUrl } from '@/helpers'
import BlankLayout from '@/Layouts/BlankLayout.vue'
import Setting from '@/setting.js'
import { useAppStore } from '@/store/index'
import StripePayment from "@/StripePayment"
import { trans, transChoice } from 'laravel-vue-i18n'
import { mapState, mapStores } from 'pinia'

export default {
   components: {
      Gallery,
      Logo,
      Card,
      Header,
      Footer,
      Body,
      Clone,
      Payment,
      AddCard
   },
   layout:BlankLayout,
   props: ["template", "user_email", "username", 'user_id'],
   data() {
      return {
         setting: new Setting(),
         isAddCardShow: false,
         displaySettings: {
            primaryColor: '#15B881',
            accentColor: '#ffffff',
         },
         isUser: false,
         isClone: false,
         product: null,
         purchaseStatus: '',
         carouselType: false,
         failReason: '',
         slides: [
         ],
         site_progress: 0,
         site_progress_message: '',
         price: 0,
         interval: '',
         processStatus: 'init',
         headerSlotClass: 'bg-grayCust-50 py-5  px-6 items-center rounded-md header-radius rounded-lg rounded-bl-none rounded-br-none ',
         mainSlotClass: 'px-6 py-16 text-center',
         footerSlotClass: 'bg-grayCust-50 py-5 justify-center px-6 rounded-lg rounded-tl-none rounded-tr-none',
         form: {
            name: this.username,
            email: this.user_email,
            template_id: this.template.id,
            product_id: this.template.product ? this.template.product.id : '',
            amount: this.price,
            payment_method: "",
            subscribe_newsletter: (this.template && this.template.hide_privacy_checkbox && this.template.email_required) ? true : false,
            user_id: this.user_id,
            post_cmd_var: null,
         },
         errors: {
            name: "",
            email: "",
            payment_method: "",
         },
         ordered_site: null,
         signupForm: {
            name: "",
            email: "",
            password: ""
         },
         signupErrors: {
            site: "",
            email: "",
         },
         cloning: "",
         loadStripeTimeOut: null,
         listenOrderEventTimeOut: null,
         isOpen3DModal: false,
         verifyURL: null,
         processing: false,
         isUserExist: 0,
         overwrite_redir: false,
      }
   },
   computed: {
      user() {
         return this.$page.props.auth.user
      },
      ...mapStores(useAppStore),
      ...mapState(useAppStore, ["getLaunchSiteCustomRedirect", "getLaunchSiteStatus", 'getLaunchSiteMessage', 'getLaunchSiteProgress', "getLaunchSiteDetail"]),
      expiredText() {
         if (this.template.is_monetized && this.form.amount > 0) {
            return window.APP.paidSiteLife + ' Days';
         }
         const options = [
            { text: transChoice('minutes', 30), value: 0.5 },
            { text: transChoice('hours', 1), value: 1 },
            { text: transChoice('hours', 2), value: 2 },
            { text: transChoice('hours', 4), value: 4 },
            { text: transChoice('hours', 8), value: 8 },
            { text: transChoice('hours', 12), value: 12 },
            { text: transChoice('hours', 24), value: 24 },
            { text: transChoice('hours', 48), value: 48 },
         ];
         if (this.template.site_life_time > 48) {
            for (let i = 3; i <= this.template.site_life_time/24; i++) {
               options.push({ text: transChoice('days', i ), value: 24 * i });
            }
         }
         
         return options.filter(option => option.value === this.template.site_life_time)[0]['text'];
      },
      templateName() {
         const templateName = this.template?.name;
         if (templateName.toLowerCase().includes('template') ||
            templateName.toLowerCase().includes(trans('template'))) {
            return this.template?.name;
         }
         return templateName + " " + trans('template');
      }
   },
   watch: {
      // whenever question changes, this function will run
      processStatus(value) {
         if (value == 'in_process') {
            if (this.price > 0) {
               this.loadStripe();
            }
            this.form.payment_method = "";
         }
      },
      getLaunchSiteStatus(value) {
         const that = this
         if (value == 'completed') {
            that.processStatus = 'complete';
            that.ordered_site = that.getLaunchSiteDetail;
            if (that.getLaunchSiteDetail.hasOwnProperty('s_hash') && that.template.auto_launch) {
               that.redirectToWpAdmin(that.getLaunchSiteDetail.s_hash)
               //window.location.href = '/wordpress-auto-login?site='+that.getLaunchSiteDetail.s_hash;
            }
         }
      },
   },
   created() {
      this.isUserExist = this.$page.props.auth.user ? 1 : 0;
      this.appStore.resetSiteInstallation()
      this.slides = this.template.gallery.sort((a, b) => b.cover - a.cover).map((item, index) => ({ ...item, className: 'templateImg' + index }));
      this.displaySettings.primaryColor = this.template.custom_primary_color ?? '#15B881';
      this.displaySettings.accentColor = this.template.custom_accent_color ?? '#ffffff';
      setCanonicalUrl(route('site.launch', { "t": this.template.slug, 'd': this.template.launch_version }));
      if (this.template?.custom_css) {
         const styleSheet = document.createElement("style")
         styleSheet.innerText = this.template.custom_css
         document.head.appendChild(styleSheet)
      }
      if (this.template.is_monetized) {
         this.product = this.template.product;
         if (this.product.payment_type != null) {
            if (this.product.payment_type == "recurring") {
               this.interval = this.product.payment_interval;
               if (this.product.payment_interval == "monthly") {
                  this.price = this.product.price;
               } else {
                  this.price = this.product.price_yearly;
               }
            } else {
               this.price = this.product.price;
            }
         } else {
            this.price = this.product.price;
         }
         this.form.amount = this.price;
         if (this.template.hasOwnProperty('order_id')) {
            this.headerSlotClass = "bg-grayCust-50 px-6 py-5 text-center rounded-lg rounded-bl-none rounded-br-none ";
            this.mainSlotClass = "p-6";
            this.footerSlotClass = "bg-grayCust-50 py-5 px-6 flex justify-center rounded-lg rounded-tl-none rounded-tr-none flex-wrap lg:flex-nowrap";

            if (this.template.hasOwnProperty('order_site_id')) {
               this.ordered_site = this.template.ordered_site;
               this.processStatus = 'complete';
            } else if (this.template.hasOwnProperty('order_id')) {
               this.processStatus = 'site_creating';
               this.form.order_id = this.template.order_id;
               this.launchSite();
            }
         }
      }
   },
   mounted() {
      if (this.template) {
         const params = route().params;
         let redirect_url = ''
         if (this.template?.can_advance_template_options) {
            redirect_url = this.template.redirect_url ? this.template.redirect_url : ''
            if (params.hasOwnProperty("redir")) {
               const uri = window.location.search.substring(1);
               const param = new URLSearchParams(uri);
               redirect_url = param.get("redir")
               this.overwrite_redir = true
            }
            if (params.hasOwnProperty("post_cmd_var")) {
               if (typeof params.post_cmd_var === 'object' && Object.keys(params.post_cmd_var).length) {
                  this.form.post_cmd_var = params.post_cmd_var
                  const queryData = Object.keys(params.post_cmd_var)
                     .map(key => key + '=' + params.post_cmd_var[key])
                     .join('&');
                  if (!redirect_url) {
                     redirect_url = '/wp-admin'
                  }
                  redirect_url = redirect_url.includes("?") ? redirect_url + '&' + queryData : redirect_url + '?' + queryData
                  this.overwrite_redir = true
               }
            }
         }

         this.appStore.updateLaunchSiteCustomRedirect(encodeURIComponent(decodeURIComponent(redirect_url)));

         if (!this.template.collect_email || this.template.hasOwnProperty('order_id') || (this.template.collect_email && (params.hasOwnProperty("email") && params.email) && this.template.skip_form_if_parm) && !this.template.is_monetized) {
            this.launchSite()
         }
      }
   },
   unmounted() {
      clearTimeout(this.loadStripeTimeOut)
      clearTimeout(this.listenOrderEventTimeOut)
   },
   methods: {
      addCardClick() {
         this.isAddCardShow = true
      },
      closeAddCard() {
         this.isAddCardShow = false;
      },
      validateEmail() {
         this.errors.email = null;
         const mailformat = /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/;
         if (this.template.is_monetized == 1 || (this.template.collect_email && this.template.email_required)) {
            if (!this.form.email || this.form.email.length == 0) {
               this.errors.email = [trans('validation.required', { 'attribute': 'email' })];
               return false;
            }
         }
         if (this.form.email && !(mailformat.test(this.form.email))) {
            this.errors.email = [trans('validation.regex', { 'attribute': 'email' })];
            return false;
         }
         return true;
      },
      cloneSite() {
         const that = this;
         that.cloning = 'init';
         if (that.user) {
            that.signupForm.name = that.user.name;
            that.signupForm.email = that.user.email;
            that.createUser()
         } else {
            that.isClone = true
         }

      },
      createUser() {
         const that = this;

         const urlArr = that.ordered_site.wp_url.split("//")
         that.cloning = 'inProcess';
         that.signupErrors = []

         axios
            .post("/user/onboard", {
               name: that.signupForm.name,
               email: that.signupForm.email,
               sub_domain: urlArr[1],
               password: that.signupForm.password,
               ga_client_id: window.ga_client_id
            })
            .then(response => {
               if (response.data.status === 0) {
                  if (response.data.exist) {
                     that.isUser = true;
                     that.cloning = 'init';
                     that.signupErrors.email = [response.data.message]
                  } else {
                     that.signupForm.email = "";
                     that.cloning = 'done';
                  }
                  that.reset();
               } else if (response.data.status === 1) {
                  if (!that.isUser) {

                  }
                  const notification = {
                     heading: that.$t('success'),
                     subHeading: response.data.message,
                     type: "success",
                  };
                  that.appStore.setNotification(notification);
                  window.location.href = that.route('dashboard');
                  that.reset();
                  that.cloning = 'done';
               }
            })
            .catch(function (error) {
               that.cloning = 'init';
               if (error.response.data.hasOwnProperty('errors')) {
                  that.signupErrors = error.response.data.errors
               } else {
                  that.signupErrors.site = error?.response?.data.message || error.message
               }
            });
      },
      loadStripe() {
         const url = `https://js.stripe.com/v3?callback=initStripe`;
         const script = document.createElement("script");
         if (document.querySelectorAll(`script[src="${url}"]`).length == 0) {
            script.setAttribute("src", url);
            document.head.appendChild(script);
            script.onload = () => this.stripeInit();
         } else {
            this.loadStripeTimeOut = setTimeout(() => {
               this.stripeInit();
            }, 30);
         }
      },
      stripeInit() {
         try {
            this.stripe = new StripePayment();
            this.stripe.mountTo("#card-element").onChange((ex) => {
               this.errors.payment_method = ex.error
                  ? ex.error.message
                  : "";
            });
         } catch (error) {
            
         }
      },
      startProcess() {
         this.processStatus = 'in_process';
         this.headerSlotClass = "bg-grayCust-50 px-6 py-5 text-center rounded-lg rounded-bl-none rounded-br-none ";
         this.mainSlotClass = "p-6";
         this.footerSlotClass = "bg-grayCust-50 py-5 px-6 flex rounded-lg rounded-tl-none rounded-tr-none flex-wrap justify-center lg:flex-nowrap";
         if (!this.template.is_monetized && !this.template.collect_email && !this.template.collect_name) {
            this.launchSite();
         }
      },
      back() {
         this.processStatus = 'init';
         this.headerSlotClass = 'bg-grayCust-50 py-5  px-6 items-center rounded-md header-radius';
         this.mainSlotClass = 'px-6 py-16 text-center';
         this.footerSlotClass = 'bg-grayCust-50 py-5 px-6 rounded-lg justify-center rounded-tl-none rounded-tr-none';
      },
      purchaseSite() {
         if (this.form.name == '') {
            this.errors.name = [trans('validation.required', { 'attribute': 'name' })];
            return;
         }
         if (this.form.email == '') {
            this.errors.name = [trans('validation.required', { 'attribute': 'email' })];
            return;
         }
         if (!this.validateEmail()) {
            return;
         }
         this.purchaseStatus = 'init';
         const that = this;
         const template = that.template;
         that.form.template_id = template.id;
         if (that.form.amount > 0) {
            if (that.form.payment_method) {
               that.createOrder();
            } else {
               that.stripe.createPaymentMethod(that.form.email, that.form.name, (result) => {
                  if (result.error) {
                     that.purchaseStatus = '';
                     that.errors.payment_method = result.error ? result.error.message : '';
                     return;
                  }
                  that.form.payment_method = result.paymentMethod.id;
                  that.createOrder();
               });
            }
         } else {
            that.createOrder();
         }
      },
      createOrder() {
         const that = this;
         that.listenOrderEvent();
         axios
            .post(`/api/v2/orders`, that.form)
            .then((response) => {
               that.form.user_id = response.data.data.buyer_id;
               that.order_token = response.data.data.token;
               that.form.order_id = response.data.data.id;
            })
            .catch((error) => {
               Echo.leave(`order.confirmation`);
               if (error.response.status == 400) {
                  that.processStatus = 'payment_process';
                  that.purchaseStatus = 'failed';
                  that.failReason = error.response.data.fail_message;
               } else {
                  that.purchaseStatus = '';
                  that.errors = error.response.data.errors;
               }
            })
            .finally(() => {
               //that.isLoading = false;
            });
      },
      createUserPaidsite() {
         this.isUserExist = 0;
         if (!this.form.user_id) {
            axios
               .post(`/api/v2/paid-site-signup`, { 'token': this.order_token, ga_client_id: window.ga_client_id })
               .then((response) => {
                  this.form.user_id = response.data.data.id;
                  this.isUserExist = 1;
               })
               .catch((error) => {
               })
         }
      },
      listenOrderEvent() {
         //Pusher.logToConsole = true;
         window.Echo.channel(`order.confirmation`)
            .listen('OrderConfirmed', (e) => {
               if (e.token == this.order_token) {
                  const status = e.hasOwnProperty('status') ? e.status : 'init';
                  this.isOpen3DModal = false;
                  if (status == 'completed') {
                     this.purchaseStatus = 'completed';
                     this.processStatus = 'payment_process';
                     Echo.leave(`order.confirmation`);
                     this.createUserPaidsite();
                     this.listenOrderEventTimeOut = setTimeout(() => {
                        this.launchSite();
                     }, 3000);
                  } else if (status == 'init' && e.hasOwnProperty('confirmation_url') && e.confirmation_url.length > 0) {
                     this.isOpen3DModal = true;
                     this.verifyURL = e.confirmation_url;
                  } else if (status == 'error' || status == 'refunded') {
                     Echo.leave(`order.confirmation`);
                     this.purchaseStatus = 'failed';
                     this.failReason = e.hasOwnProperty('failReason') ? e.failReason : 'Your card has insufficient funds.';
                     this.processStatus = 'payment_process';
                     const notification = {
                        heading: trans("error"),
                        subHeading: trans("purchase_failed"),
                        type: "error",
                     };
                     this.appStore.setNotification(notification);
                  }
               }
            });
      },
      async launchSite() {
         if (this.template.is_monetized == 0 && !this.validateEmail()) {
            return;
         }
         this.initializeSiteInstallationProcess();
         this.processStatus = 'site_creating';
         const that = this;
         //await that.recaptcha();
         that.siteCreating = true;
         let url = route('template.launchsite.api', this.template.id);

         if (this.template.server_type == 'my_hosting') {
            url = route('template.hostingprovidersite.api', [this.template.id, this.randomStr]);
            this.site_installing_status = 'installing';
         } else {
            that.appStore.resetSiteInstallation()
            if (this.form.email && this.template.hide_privacy_checkbox) {
               this.form.subscribe_newsletter = true
            }
         }
         that.appStore.updateLaunchSiteStatus('waiting');
         axios
            .post(url, this.form)
            .then((response) => {

               if (that.template.server_type != 'my_hosting') {
                  that.email = that.form.email

                  that.appStore.updateLaunchSiteStatus('processing');
                  that.appStore.updateLaunchSiteDetail(response.data.data);

                  if (response.data.data.is_pool) {
                     that.appStore.updateLaunchSiteStatus('completed');
                     this.setSiteDetailOnLocalStorage(response.data.data)
                  } else {
                     that.appStore.setSiteTaskId(response.data.data.task_id);
                     that.appStore.subscribeSiteInstallationProgressEvent(true);
                  }

               }

            }).catch((error) => {
               

               const message = error?.response?.data.message || error.message
               that.errors.site = message;

               that.appStore.updateLaunchSiteStatus('failed');
               that.appStore.updateLaunchSiteMessage({
                  heading: that.$t('installation_failed'),
                  subHeading: message,
               });
            }).finally(() => {
               that.reset();
            });
      },
      reset() {
         this.form = {
            name: this.username,
            email: this.user_email,
            template_id: this.template.id,
            amount: this.price,
            payment_method: "",
            user_id: this.user_id,
            subscribe_newsletter: false,
            post_cmd_var: null,
         };

         this.errors = {
            site: "",
            email: "",
         };
      },
      initializeSiteInstallationProcess() {
         const that = this;
         that.randomStr = Math.random().toString(36).slice(2);

         window.Echo.channel(`template.hosting.account.site.installation.${that.randomStr}`).listen("TemplateHostingProviderSiteProgress", (e) => {

            if (e.hasOwnProperty('progress') && e.progress == 0) {
               that.site_installing_status = 'failed';
               that.initializeSiteInstallationProcess();
            }

            that.site_progress = e.progress;
            that.site_progress_message = e.message;

            if (e.hasOwnProperty('progress') && e.progress == 100) {
               that.createdsitedetails = e.data;
               that.site_installing_status = 'completed';
               that.processStatus = 'complete';
               Echo.leave(`template.hosting.account.site.installation.${that.randomStr}`);
               that.initializeSiteInstallationProcess();
            }

         });
      },
      inIframe() {
         try {
            return window.self !== window.top;
         } catch (e) {
            return true;
         }
      },
      async redirectToWpAdmin(site_hash = null) {
         const that = this;
         that.errors.site = ''
         that.processing = true;
         const query = { "redirect": true, site_hash, "redir": decodeURIComponent(that.getLaunchSiteCustomRedirect) }
         if (that.overwrite_redir) {
            query.overwrite_redir = true
         }
         axios.get(route('site.launchwpadmin.api'), { params: query })
            .then(function (response) {
               if (that.inIframe()) {
                  window.top.location.href = response.data.data.redirect_url
               } else {
                  window.location.href = response.data.data.redirect_url;
               }
            }).catch(function (error) {
               that.processing = false;
               
               const message = error?.response?.data.message || error.message
               that.errors.site = message
            });
      },
      magicLogin() {
         window.open(`${route('autologin')}?site=${this.ordered_site.s_hash}${(this.getLaunchSiteCustomRedirect) ? '&redir=' + this.getLaunchSiteCustomRedirect : ''}${(this.overwrite_redir) ? '&overwrite_redir=true' : ''}`);
      },
      setSiteDetailOnLocalStorage(siteDetails) {
         localStorage.setItem('iwp_demo_site_id', siteDetails.id)
         localStorage.setItem('iwp_demo_site_url', siteDetails.url)
      },
   }
}
</script>

<style scoped>
.slider-width {
   width: 50%;
}

.card-main {
   background: #FFFFFF;
   width: 562px;
   border-radius: 16px;
   box-shadow: 4px 4px 16px rgba(0, 0, 0, 0.06);
}

@media screen and (max-width:1200px) {
   .slider-width {
      width: 100%;
   }

   .btn-width-main {
      padding: 40px 0 40px;
   }
}

@media screen and (max-width:576px) {

   .card-main,
   .btn-width-main {
      width: 100%;
   }
}

@media (max-height: 750px) {
   .clone-site-align {
      align-items: start !important;
   }
}

@media (min-height: 750px) {
   .clone-site-align {
      align-items: center !important;
   }
}

@keyframes spin {
   from {
      transform: rotate(360deg);
   }

}

.spin {
   animation: spin 1s linear infinite;
}

@media (max-height: 700px) {
   .slider-width {
      align-items: start !important;
      padding: 50px 0;
   }
}
</style>